(() => {
  class TradeproLocalization extends HTMLElement {
    connectedCallback() {
      if (this.dataset.tradeproLocalizationReady === 'true') return;

      const form = this.querySelector('form');
      const select = this.querySelector('[data-tradepro-localization-select]');

      if (!form || !select) return;

      this.dataset.tradeproLocalizationReady = 'true';

      select.addEventListener('change', () => {
        this.setAttribute('aria-busy', 'true');
        form.submit();
      });
    }
  }

  if (!customElements.get('tradepro-localization')) {
    customElements.define('tradepro-localization', TradeproLocalization);
  }
})();
